import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import App from "./App.tsx";
import "./index.css";

const clearPreviewCaches = async () => {
  if (typeof window === "undefined") return;

  const isPreviewHost = window.location.hostname.includes("lovableproject.com") || window.location.hostname.includes("lovable.app");
  if (!isPreviewHost) return;

  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }

    if ("caches" in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }

    const reloadKey = "preview-cache-reset-v1";
    if (sessionStorage.getItem(reloadKey) !== "done") {
      sessionStorage.setItem(reloadKey, "done");
      window.location.reload();
    }
  } catch (error) {
    console.warn("[preview-cache-reset] Failed to clear preview caches", error);
  }
};

clearPreviewCaches().then(() => {
  const container = document.getElementById("root");
  if (container && !(container as any).__reactRoot) {
    const root = createRoot(container);
    (container as any).__reactRoot = root;
    root.render(
      <HelmetProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </HelmetProvider>
    );
  }
});
